import { useEffect, useState, useCallback } from "react";
import { getAllLoanInfo, getReportData, getAllCity, getLoanOfficers, getReportNames, getFundSource, getAllCounty, getAllLoanStatus } from "../Service";
import useBorrowerType from "app/views/borrowerType/hooks/useBorrowerType";
import useLoanType from "app/views/loantype/hooks/useLoanType";
import useLoanStatus from "app/views/loanstatus/hooks/useLoanStatus";


const useReportsData = () => {
    const [loannums, setLoanNums] = useState([]);
    const [citys, setCitys] = useState([]);
    const [countys, setCountys] = useState([]);
    const [loanofficers, setLoanOfficers] = useState([]);
    const [reportNames, setReportNames] = useState([]);
    const [fundSources, setFundSources] = useState([]);
    const { borrowerTypeList, updatePageData: updateBorrowerTypes } = useBorrowerType();
    const { loanTypes, updatePageData: updateLoanTypes } = useLoanType();
    const [loanStatusList, setLoanStatusList] = useState([]);

    //
    const fetchAllLoanStatus = useCallback(() => {
        getAllLoanStatus().then(response => {
            console.log(response);
            setLoanStatusList(response.data.loanStatus || []);
        }).catch(error => {
            console.error('Failed to fetch loan status data', error);
        });
    }, []);

    const fetchDropdownData = useCallback(() => {
        getAllLoanInfo().then(response => {
            setLoanNums(response.data.loanInfos || []);
        }).catch(error => {
            console.error('Failed to fetch Loan Info data', error);
        });
    }, []);


    const fetchCityData = useCallback(() => {
        getAllCity().then(response => {
            console.log('City Data Response:', response);
            setCitys(response.data.citys || []);
        }).catch(error => {
            console.error('Failed to fetch City data', error);
        });
    }, []);

    const fetchCountyData = useCallback(() => {
        getAllCounty().then(response => {
            setCountys(response.data.countys || []);
        }).catch(error => {
            console.error('Failed to fetch County data', error);
        });
    }, []);

    const fetchLoanOfficers = useCallback(() => {
        getLoanOfficers().then(response => {
            console.log('Loan Officers Response:', response);
            setLoanOfficers(response.data || []);
        }).catch(error => {
            console.error('Failed to fetch City data', error);
        });
    }, []);

    const fetchFundSources = useCallback(() => {
        getFundSource().then(response => {
            console.log('Fund Sources Response:', response);
            setFundSources(response.data || []);
        }).catch(error => {
            console.error('Failed to fetch Fund Sources data', error);
        });
    }, []);

    const fetchReportNames = useCallback(() => {
        getReportNames()
            .then((response) => {
                console.log('Report Names API Response:', response);
                // Support multiple possible API response shapes
                let rawData = response?.data?.reportNames || response?.data || [];
                
                // Ensure it's an array
                if (!Array.isArray(rawData)) {
                    rawData = [];
                }
                
                // Normalize to array of strings
                const normalizedNames = rawData
                    .map((item) => {
                        if (typeof item === 'string') return item;
                        if (item && typeof item === 'object') return item.name || item.Name || null;
                        return null;
                    })
                    .filter(Boolean);
                
                console.log('Normalized Report Names:', normalizedNames);
                setReportNames(normalizedNames);
            })
            .catch((error) => {
                console.error('Failed to fetch report name data', error);
                setReportNames([]);
            });
    }, []);

    const fetchReportData = async (params) => {
        try {
            console.log('Fetching report data with params:', params);
            const response = await getReportData(params);

            // If response.data is already an object, no need to parse
            console.log('Parsed Report:', response.data);
            //setReportData(JSON.stringify(response.data));
            return response.data;
        } catch (err) {
            console.error('Error fetching report data:', err);
        }
    };

    useEffect(() => {
        fetchDropdownData();
        fetchCityData();
        fetchCountyData();
        fetchLoanOfficers();
        fetchFundSources();
        fetchReportNames();
        updateBorrowerTypes();
        updateLoanTypes();
        fetchAllLoanStatus();
    }, []);



    //return { data, loading, error };
    return { loannums, citys, countys, loanofficers, reportNames, borrowerTypeList, loanTypes, loanStatusList, fundSources, fetchReportData };
};

export default useReportsData;